/* global G */
/* eslint-disable object-curly-newline, no-alert, no-restricted-globals,no-unused-vars */
import routeComposition from 'trait/composition/route'
import { curry, getFirstItem, isStr } from 'lib/util'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'
import { acl } from 'app/_shared/events/acl'
import { chain } from 'app/_shared/events/util'
import { back, persistChange, persistOptions, persistScroll, redirect } from 'app/_shared/events'
import menu from 'app/_shared/events/contextmenu'
import link from 'app/_shared/events/link'
import toAction from 'app/_shared/events/redirect/toAction'
import remember from 'app/_shared/events/remember'
import persistChangeAndAction from 'app/_shared/events/combined/persistChangeAndAction'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import infiniteWithDrafts from 'app/_shared/events/search/infiniteWithDrafts'
import getPassword from 'app/optionManagement/event/getPassword'
import submit from 'app/optionManagement/event/submit'
import getClipboardAndPersistChangeAndAction from 'app/optionManagement/event/getClipboardAndPersistChangeAndAction'
import getValueAndProcessCode from 'app/optionManagement/event/getValueAndProcessCode'
import deletePinOrOptionWithDrafts from 'app/optionManagement/event/deletePinOrOptionWithDrafts'

export default {
  acl: {
    acl,
  },
  onCreate: {
    createRedirect,
  },
  onOpen: {
    infiniteWithDrafts: infiniteWithDrafts('verbose'),
    link,
  },
  onClose: {
    back,
  },
  onClick: {
    submit: submit(null),
    submitOption: submit('submitOption'),
    back,
    redirect,
    redirectToEquipment: curry(async (module, component, event) => {
      const model = module[G.MODEL]
      const { equipment: { [G.CACHE]: equipment = {} } = {} } = model[G.CHILDREN] || {}
      const equipmentData = equipment && getFirstItem(equipment)
      const key = equipmentData && isStr(equipmentData) ? equipmentData : equipmentData?.key

      const moduleState = module[G.STATE]
      const { route } = component[G.CONFIGURATION]
      moduleState[G.ROUTE] = routeComposition(route.module, route.action)

      key && await redirectSequence(module)({ key })
    }),
    getValueAndProcessCode,
    getClipboardAndPersistChangeAndAction,
    detail: toAction('detail'),
    getPassword,
    delete: deletePinOrOptionWithDrafts,
  },
  onChange: {
    persistOptions,
    persistChange,
    persistChangeAndAction,
  },
  onContextMenu: {
    menu: menu(null),
  },
  onPage: {
    remember,
  },
  onScroll: {
    persistScrollAndRemember: chain(
      persistScroll,
      remember,
    ),
  },
}
